import DefinitionsList from "./DefinitionsList";
export default DefinitionsList;
